import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// This imports the main stylesheet.
import './App.css';

// This is the standard way to initialize a React app.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);